import { useEffect, useState } from "react"
import { Modal, Button } from "@mui/material"
import MDBox from "../MDBox"
import MDTypography from "../MDTypography"
import MDInput from "components/MDInput"

const ModalLeaveAlert = (props) => {
  const { isOpen, onClose, onSubmit } = props

  const [reason, setReason] = useState("")
  const [error, setError] = useState("")

  useEffect(() => {
    if (isOpen) {
      setReason("")
      setError("")
    }
  }, [isOpen])

  const handleChangeReason = (e) => {
    const value = e.target.value
    setReason(value)

    if (error && value.trim()) {
      setError("")
    }
  }

  const handleSubmit = () => {
    if (!reason.trim()) {
      setError("Reason is required")
      return
    }

    setError("")
    onSubmit?.(reason.trim())
  }

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="modal-leave-alert-container" style={{ width: "500px" }}>
        <div className="modal-leave-alert-container-wrapper">
          <MDBox className="modal-leave-alert-header">
            <MDBox>
              <MDTypography sx={{ fontSize: "18px", fontWeight: "bold" }}>
                Reasons for reject
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDBox className="modal-leave-alert-content">
            <MDTypography sx={{ textAlign: "left", mb: 1, fontSize: "14px" }}>
              Reason <sup style={{ color: "red" }}>*</sup>
            </MDTypography>

            <MDInput
              value={reason}
              onChange={handleChangeReason}
              placeholder="Enter reason"
              fullWidth
              multiline
              rows={4}
              error={!!error}
            />

            {!!error && (
              <MDTypography
                sx={{
                  color: "red",
                  fontSize: "13px",
                  mt: 0.5,
                }}
              >
                {error}
              </MDTypography>
            )}
          </MDBox>

          <MDBox
            className="modal-leave-alert-footer"
            sx={{
              display: "flex",
              gap: 2,
              mt: 2,
            }}
          >
            <Button
              color="secondary"
              className="cancel-button"
              onClick={onClose}
              sx={{ width: "100%" }}
            >
              Close
            </Button>

            <Button
              className="submit-button"
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              sx={{ width: "100%" }}
            >
              Submit
            </Button>
          </MDBox>
        </div>
      </div>
    </Modal>
  )
}

export default ModalLeaveAlert
